export const ADD_TABLE='ADD_TABLE'
export const ADD_TABLE_SUCCESS= 'ADD_TABLE_SUCCESS'
export const ADD_TABLE_ERROR= 'ADD_TABLE_ERROR'

export const AddTable= (data) => ({
    type: ADD_TABLE,
    payload: data
});
